import {
  getActionNameWithStatus,
  getResetAction,
} from "../../constants/actions-methods";
import { requestStatus } from "../../constants/request";
import { serverApis } from "../../constants/server-apis";

export const shippmentAttachmentListReducer = (state = [], action) => {
  const actionName = serverApis.getShippmentAttachmentList.actionName;
  switch (action.type) {
    case getActionNameWithStatus(actionName, requestStatus.SUCCESS):
      return action.json.attachments;

    case getResetAction(actionName):
      return [];
    default:
      return state;
  }
};
